import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ShoppingBag } from 'lucide-react';
import { useWishlist } from '../context/WishlistContext';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [selectedSize, setSelectedSize] = useState(product.sizes?.[0] || null);
  const [showAddedMsg, setShowAddedMsg] = useState(false);

  const { isInWishlist, addToWishlist, removeFromWishlist } = useWishlist();
  const { addToCart } = useCart();

  const inWishlist = isInWishlist(product.id);

  // ✅ SAFE IMAGE HANDLING
  const image1 = product.images?.[0];
  const image2 = product.images?.[1];

  const displayImage =
    isHovered && image2
      ? image2
      : image1 || "https://via.placeholder.com/400x500?text=No+Image";

  // Wishlist Toggle
  const handleWishlist = (e) => {
    e.preventDefault();
    if (inWishlist) {
      removeFromWishlist(product.id);
    } else {
      addToWishlist(product);
    }
  };

  // Add to Cart
  const handleAddToCart = (e) => {
    e.preventDefault();
    addToCart(product, selectedSize);
    setShowAddedMsg(true);
    setTimeout(() => {
      setShowAddedMsg(false);
    }, 2000);
  };

  return (
    <Link
      to={`/product/${product.id}`}
      className="group block animate-fade-in"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-testid={`product-card-${product.id}`}
    >

      {/* IMAGE CONTAINER */}
<div className="product-border-ring aspect-[4/3] rounded-xl">
  <div className="relative overflow-hidden rounded-xl h-full bg-white">

    <img
      src={displayImage}
      alt={product.name}
      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
    />

    {/* Wishlist Button */}
    <button
      onClick={handleWishlist}
      className={`absolute top-4 right-4 p-2 rounded-full backdrop-blur-md transition-all duration-300 ${
        inWishlist
          ? 'bg-bronze text-white'
          : 'bg-white/80 text-charcoal hover:bg-bronze hover:text-white'
      }`}
    >
      <Heart size={18} fill={inWishlist ? 'currentColor' : 'none'} />
    </button>

  </div>
</div>

      {/* Toast Message */}
      {showAddedMsg && (
        <div className="fixed bottom-6 right-6 bg-[#ba8245] text-white px-6 py-3 rounded-lg shadow-lg text-sm font-medium z-50">
          Product added to cart ✓
        </div>
      )}

      {/* PRODUCT INFO */}
      <div className="mt-4 space-y-2">
        <h3
          className="font-serif text-lg text-charcoal group-hover:text-bronze transition-colors"
          data-testid={`product-name-${product.id}`}
        >
          {product.name}
        </h3>

        <p className="text-xs uppercase tracking-widest text-[#6B665F] font-light">
          {product.fabric || "Vanya"}
        </p>

        <p
          className="font-sans text-bronze font-medium"
          data-testid={`product-price-${product.id}`}
        >
          ₹{product.price ? product.price.toLocaleString() : "0"}
        </p>
      </div>

    </Link>
  );
};

export default ProductCard;